import { DatePicker } from "antd";
import 'antd/dist/antd.min.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import axios from 'axios';
import moment from 'moment';
import propTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import { getConferenceBookings, getConferences } from '../../actions/conference';
import Loader from '../layout/Loader';
import ConferenceCarousel from './ConferenceCarousel';

AOS.init({
  duration: 1200,
});

const Conference = ({auth: { user, isAuthenticated}, getConferences, conference: {conferences}, getConferenceBookings}) => {

  useEffect(() => {
    getConferences();
  }, [getConferences]);

  useEffect(() => {
    getConferenceBookings();
  }, [getConferenceBookings]);

  const [availableConferences, setAvailableConferences] = useState(conferences);
  const [allConferences, setAllConferences] = useState([]);
  const [date, setdate] = useState('')
  const [loading, setloading] = useState(false);

  function filterByDate(date) {
    setdate(moment(date).format('DD-MM-YYYY'));

    var temp = [];

    for(const conference of allConferences) {
      var availability = false;
      if (conference.currentbookings.length > 0) {
        for(const booking of conference.currentbookings){
          if(conference.currentbookings.length){
            var bookedDate = booking.dateon.toString();
            var selectedDate = (moment(date).format('DD-MM-YYYY')).toString();
            if(bookedDate !== selectedDate){
              availability = true;
            }
          }
        }
        if(availability === true || conference.currentbookings.length === 0) {
            temp.push(conference);
        }
        setAvailableConferences(temp);
      } else {
        setAvailableConferences(conferences);
      }
    }
  }

  useEffect(() => {
      const loadConferences = async () => {
        setloading(true);
        const conferences = await(await axios.get("/api/conference")).data;
        //console.log(conferences);
        setAvailableConferences(conferences);
        setAllConferences(conferences);
        setloading(false);
      }
      loadConferences(); //eslint-disable-next-line
  }, []); 
  
  return (
    <>
        <ConferenceCarousel/>
        <div className='container'>
          {isAuthenticated && user && user.usertype === 'guest' &&
          <div style={{textAlign: 'right'}}>
              <Link to='/conferencebookings'><button type="button" class="btn btn-warning" >Your Conference Bookings</button></Link>
          </div>
          }
          <div className="row bs p-3 m-5 dark" data-aos="fade-up">
            <div className="col-md-6">
              <h5 style={{marginTop: '10px'}}>Select Date</h5>
            </div>
            <div className="col-md-6">
              <DatePicker style={{ height: "38px", width: "98%" }} onChange={filterByDate} format='DD-MM-YYYY' className='m-2' />
            </div>
        </div>

        <div className="row justify-content-center mt-5"  >
            {loading ? (
                <Loader />
            ) : (
                <div className="col-md-9 mt-2">
                    {availableConferences.map((conference) => (
                        <div className='row bs' key={conference._id} data-aos='zoom-in'>
                            <div className='col-md-4'>
                                <img src={conference.imageurl[0]} alt = 'conference img'></img>
                            </div>
                            <div className='col-md-7'>
                                <h4>{conference.name}</h4>
                                <div style={{ float: 'right', paddingLeft: '14px' }}>
                                    {date && isAuthenticated && user && user.usertype === 'guest' && (
                                        <LinkContainer to={`/bookconference/${conference._id}/${date}`}>
                                          <button className='btn btn-outline-success'>Book Now</button>
                                        </LinkContainer>)
                                    }
                                    {date && !isAuthenticated && (
                                        <Link to='/guestLogin'>
                                          <button className='btn btn-outline-success'>Login to Book</button>
                                        </Link>)
                                    }
                                </div>
                                
                                <div style={{ float: 'right', paddingLeft: '14px' }}>
                                    <LinkContainer to={`/conference/${conference._id}`}>
                                      <button className='btn btn-outline-warning'>More Info</button>
                                    </LinkContainer>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>

        <hr style={{paddingTop: '20px', paddingBottom: '20px'}}/>
        </div>
    </>
  )
};

Conference.propTypes = {
    auth: propTypes.object.isRequired,
    conference: propTypes.object.isRequired,
    getConferences: propTypes.func.isRequired,
    getConferenceBookings: propTypes.func.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    conference: state.conference
});

export default connect(mapStateToProps, {getConferences, getConferenceBookings})(Conference);